import React from "react";

interface StreakIconProps {
  className?: string;
  onClick?: () => void;
}

export const StreakIcon = ({ className, onClick }: StreakIconProps) => (
  <svg
    width="18"
    height="23"
    viewBox="0 0 18 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <defs>
      <linearGradient id="streak">
        <stop offset="0%" stopColor="#FFC446" />
        <stop offset="99.99%" stopColor="#F15A28" />
        <stop offset="100%" stopColor="#F15A28" />
      </linearGradient>
    </defs>
    <path
      d="M10.0312 1.78125C10.0312 2.58333 10.2747 3.34245 10.7617 4.05859C11.2773 4.77474 11.8789 5.44792 12.5664 6.07812C13.2826 6.70833 13.9844 7.38151 14.6719 8.09766C15.388 8.8138 15.9896 9.73047 16.4766 10.8477C16.9922 11.9362 17.25 13.1536 17.25 14.5C17.25 16.763 16.4336 18.6966 14.8008 20.3008C13.1966 21.9336 11.263 22.75 9 22.75C6.73698 22.75 4.78906 21.9336 3.15625 20.3008C1.55208 18.6966 0.75 16.763 0.75 14.5C0.75 12.2656 1.53776 10.332 3.11328 8.69922C3.42839 8.35547 3.80078 8.26953 4.23047 8.44141C4.66016 8.61328 4.875 8.94271 4.875 9.42969V13.082C4.875 13.8555 5.13281 14.5143 5.64844 15.0586C6.19271 15.6029 6.83724 15.875 7.58203 15.875C8.35547 15.875 9.01432 15.6172 9.55859 15.1016C10.1029 14.5573 10.375 13.8984 10.375 13.125C10.375 12.638 10.2318 12.1654 9.94531 11.707C9.6875 11.2487 9.3724 10.8333 9 10.4609C8.6276 10.0885 8.22656 9.70182 7.79688 9.30078C7.39583 8.89974 7.05208 8.45573 6.76562 7.96875C6.50781 7.48177 6.33594 6.9375 6.25 6.33594C6.16406 5.73438 6.26432 5.00391 6.55078 4.14453C6.86589 3.25651 7.39583 2.28255 8.14062 1.22266C8.42708 0.792969 8.8138 0.64974 9.30078 0.792969C9.78776 0.936198 10.0312 1.26562 10.0312 1.78125Z"
      fill="#D1D4DE"
    />
  </svg>
);

StreakIcon.defaultProps = {
  className: "",
  onClick: undefined,
};
